<script setup lang="ts">

import MapWebGL from '@/components/Sections/Map/Galaxy/WebGLMap/MapWebGL.vue'
import { useMapSettingsStore } from '@/stores/mapSettingsStore'

const mapSettingsStore = useMapSettingsStore()

</script>

<template>
  <div :class="mapSettingsStore.hideBackgroundImage ? 'galaxy-background-hidden' : 'galaxy-background'">
    <MapWebGL></MapWebGL>
  </div>
</template>

<style scoped lang="scss">
.galaxy-background {
  background-image: url("https://cdn.ferion.com/images/backgrounds/space.webp");
}
.galaxy-background-hidden {
  background-image: none;
  background-color: #000;
}
</style>